import GongqiFormItemControl from './GongqiFormItemControl';
import CmdTypeActions from '../../actions/CmdTypeActions';

export default class FormItemButtonBaseControl extends GongqiFormItemControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemButtonBaseControl";
	}

	isSkipTab()
	{
		//TODO Group折叠考虑
		//if(getGroupParentFolded())
		//	return true;
		
		
		if(!this.getProperty_Visible_FinalusersetLoopForSkip())
			return true;
		if(this.getProperty_ActualSkipTab())
			return true;
		
		return false;
	}

	getProperty_ShortCut()
	{
		var _parentWindow = window.parent.window;
		if(!this.forLookup && _parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId+"."+window.formId))
		{
			let _userProperties = _parentWindow.userProperties[window.menuItemId+"."+window.formId];
			let _properties = _userProperties[this.xml.id];
			if(_properties && ( _properties.hasOwnProperty("shortcut") || _properties.hasOwnProperty("shortCut")))
				return _properties["shortcut"] || _properties["shortCut"];
		}
		return this.properties.ShortCut;
	}

	getProperty_SaveRecord()
	{
		if(this.properties.hasOwnProperty("SaveRecord"))
			return this.properties.SaveRecord;
		return this.properties.AutoSaveRecord;
	}

	getProperty_Icon()
	{
		if(this.properties.hasOwnProperty("Icon"))
			return this.properties.Icon;
		return this.properties.HasIcon;
	}

	setControlLabelCmd(value)
	{
		this._cmdLabel = value;
		CmdTypeActions.updateControlLabel(this.xml.name,value,this.module.instanceUUId);
	}
}


// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemButtonBaseControl.js